export default __webpack_public_path__ + "static/media/2197.891611b3.png";